import Request from ".";
import { Routes } from "../constant/api_url";

const UpdateSetting = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATESETTING, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getSetting = async () => {
  try {
    const result = await Request.get(Routes.GETESETTING);
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getSettingHistory = async () => {
  try {
    const result = await Request.get(Routes.GETSETTINGHISTORY);
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getContentHistory = async (type = 0) => {
  try {
    const result = await Request.get(Routes.GETCONTENTHISTORY, { params: { type } });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const updateInvoiceStart = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATEINVOICESTART, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const insertLvbDataApi = async (data) => {
  try {
    const result = await Request.post(Routes.INSERTLVBDATA, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getLvbDataApi = async () => {
  try {
    const result = await Request.get(Routes.GETLVBDATA);
    return result.data;
  } catch (error) {
    throw error;
  }
};

// const chapterSetting = async () => {
//   try {
//     const result = await Request.get(Routes.GETESETTING);
//     return result.data;
//   } catch (error) {
//     throw error;
//   }
// };

export { UpdateSetting, getSetting, getSettingHistory, getContentHistory, updateInvoiceStart, insertLvbDataApi, getLvbDataApi };
